const injectMarketTool = loginInfo => {
  if (!loginInfo) return;
  setTimeout(() => {
    if (window.Intercom) {
      window.Intercom('boot', {
        app_id: 'u8nmlvji',
        email: loginInfo.email,
        user_id: loginInfo.id,
        created_at: Math.floor(loginInfo.createdAt / 1000),
        user_type: loginInfo.hasPlanExpired ? 'EXPIRED' : loginInfo.realType,
        plan_id: loginInfo.planId,
        plan_expired_at:
          loginInfo.planExpiredAt > 0
            ? Math.floor(loginInfo.planExpiredAt / 1000)
            : null,
        plan_mode: loginInfo.planMode,
      });
    }
  }, 1000);
};

export default {
  injectMarketTool,
};
